export const customEvent = (name: string, detail: any) => new CustomEvent(
  name,
  {
    bubbles: true,
    composed: true,
    detail
  }
);
